

















import Vue from "vue";
import Form from "../../components/Form.vue";
import { Auth } from "@isocial-vue/blueprint";

export default Vue.extend({
  components: {
    Form,
  },
  beforeMount() {
    this.alert = false;
    const claims = Auth.claims;
    if (!claims) return;

    if (!claims.BCE) {
      this.alert = true;
      return;
    }

    (this.apiData as any) = {
      CBENumber: claims.BCE,
      companyName: claims.company,
    };
  },
  data() {
    return {
      alert: false,
      apiData: null,
    };
  },
  methods: {
    logout() {
      Auth.logOut();
    },
  },
});
